// extracted by mini-css-extract-plugin
module.exports = {"header_zeroPrice":"header_zeroPrice-26d9I","price__wrapper":"price__wrapper-3Fxg7","header":"header-XqiCM","stepIndex__label":"stepIndex__label-9jrjw"};